import React from 'react';
import styles from './VisitorTrackingWelcome.module.css';
import WelcomeImage from './images/welcome.png';
import { DemoButtons } from '../DemoButtons/DemoButtons';

export const VisitorTrackingWelcome = ({ isMobile }) => (
  <div className={styles.wrapper}>
    <div className={styles.welcome_section}>
      <div className={styles.welcome_text}>
        <p className={styles.welcome_subtitle}>
          Reliable visitor tracking is here!
        </p>
        <h2 className={styles.welcome_title}>
          Don’t let third-party data loss get you down
        </h2>
        <p className={styles.welcome_description}>
          Take back the website visitor tracking capabilities you once had with
          first-party data and customer journey insights.
        </p>
      </div>
      <DemoButtons isMobile={isMobile} />
    </div>
    <img
      src={WelcomeImage}
      width={400}
      height={320}
      role="presentation"
      className={styles.welcome_image}
    />
  </div>
);
